'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Toggle = require('./Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Toggle/index.js
// module id = ./node_modules/material-ui/Toggle/index.js
// module chunks = index